import queryString from "query-string";

const href = location.href.toString();

const getQuery = () => {
  const match = window.location.href.match(/\?(.*)$/);
  const search = match ? match[1] : "";
  const query = queryString.parse(search, {
    parseBooleans: true,
  });
  return query;
};

/**
 * 获取操作系统
 */
const getOperationSystem = () => {
  const platform = navigator.platform.toLowerCase();
  const userAgent = navigator.userAgent.toLowerCase();

  if (platform.indexOf("mac") >= 0) {
    return "macos";
  } else if (platform.indexOf("win") >= 0) {
    return "windows";
  } else if (/linux/i.test(userAgent)) {
    return "linux";
  } else {
    return "other";
  }
};

/**
 * 获取设备类型
 */
const getDeviceType = () => {
  if (
    /(iphone|ios)/i.test(navigator.userAgent) ||
    /(android)/i.test(navigator.userAgent)
  ) {
    return "mobile";
  } else if (/(ipad)/i.test(navigator.userAgent)) {
    return "pad";
  } else {
    return "pc";
  }
};

// const isNative = () => {
//   return (
//     navigator.userAgent.indexOf('dtdreamweb') > -1 ||
//     navigator.userAgent.indexOf('AlipayClient') > -1
//   );
// }

const getEndpoint = () => {
  const query = getQuery();
  return query["guc-endpoint"] || "C";
};

const getUserType = () => {
  const query = getQuery();
  return query["guc-accountType"] || "person";
};

const getGucPlatform = () => {
  return /portal/gi.test(href) ? "pc" : "pc";
};

export default function deviceFactor() {
  // https://aone.alibaba-inc.com/project/896515/req?akProjectId=896515
  // rc: receivingChannel （rc,收单渠道）: 浙里办h5，浙里办native，支付宝小程序，政务服务网，线下一窗，线下pad等（前端根据配置公式传递）

  return {
    // bizChannel: '',
    // receivingSystem: getReceivingSystem(),
    "gov-os": getOperationSystem(),
    "gov-dt": getDeviceType() === "pc" ? "pc" : "h5",
    "guc-accountType": getUserType(),
    "guc-platform": getGucPlatform(),
    "guc-endpoint": getEndpoint(),
    userType: getUserType(),
  };
}
